/**
 * ImpressumPage
 *
 * Gesetzlich vorgeschriebenes Impressum (AT/DE). Inhalt ist Platzhalter
 * für den finalen Wortlaut, den Anna noch liefern muss — Adresse,
 * Berufsbezeichnung, Aufsichtsbehörde, etc.
 */

import { Seo } from '@/components/Seo'
import './ContentPage.css'

export function ImpressumPage() {
  return (
    <article className="content-page">
      <Seo
        title="Impressum"
        description="Impressum und rechtliche Hinweise zu sachersantana.com."
      />
      <div className="content-container content-container-prose">
        <header className="content-header content-header-prose">
          <h1>Impressum</h1>
        </header>

        <div className="markdown-prose">
          <h2>Diensteanbieterin</h2>
          <p>
            Anna Sacher Santana<br />
            Bildhauerin und Fachärztin für Kinder- und Jugendpsychiatrie<br />
            Atelier am Wörthersee, Österreich
          </p>

          <h2>Kontakt</h2>
          <p>
            E-Mail: <a href="mailto:anna@sachersantana.com">anna@sachersantana.com</a>
          </p>

          <h2>Inhaltliche Verantwortung</h2>
          <p>Anna Sacher Santana</p>

          <h2>Urheberrecht</h2>
          <p>
            Alle Inhalte dieser Website (Texte, Bilder, 3D-Modelle und Skulpturenaufnahmen)
            unterliegen dem Urheberrecht. Eine Vervielfältigung oder Verwendung außerhalb
            dieser Website ist ohne ausdrückliche schriftliche Zustimmung nicht gestattet.
          </p>

          <h2>Haftungsausschluss</h2>
          <p>
            Trotz sorgfältiger inhaltlicher Kontrolle wird keine Haftung für die Inhalte
            externer Links übernommen. Für den Inhalt der verlinkten Seiten sind ausschließlich
            deren Betreiber:innen verantwortlich.
          </p>

          <p className="markdown-prose-meta">
            <em>Hinweis: Vollständige Impressums-Angaben (Anschrift, Berufsbezeichnung,
            zuständige Kammer / Aufsichtsbehörde) werden noch ergänzt.</em>
          </p>
        </div>
      </div>
    </article>
  )
}
